import { parseHTML } from '../../modules/Parsers';

const parseComments = (data, postAuthor) =>
  data.comments.map(comment => parseComment(comment, postAuthor));

const parseComment = (comment, postAuthor) => {
  const { author, created_utc, replies, id, likes, body_html } = comment;
  const isOP = author.name === postAuthor;
  const parsedBody = parseHTML(body_html);
  const parsedReplies =
    replies && replies.length > 0
      ? replies.map(reply => {
          return parseComment(reply, postAuthor);
        })
      : [];

  return {
    body: parsedBody,
    replies: parsedReplies,
    timeAgo: created_utc,
    byOP: isOP,
    author: author.name,
    vote: parseVote(likes),
    id,
  };
};

const parseSelftext = selftext => parseHTML(selftext ?? '');

const getGiphyImageURL = url => {
  let parsedURL;
  try {
    parsedURL = new URL(url);
  } catch (error) {
    if (error instanceof TypeError) return null;
    throw error;
  }

  if (
    !['http:', 'https:'].includes(parsedURL.protocol) ||
    !['giphy.com', 'www.giphy.com'].includes(parsedURL.hostname)
  ) {
    return null;
  }

  const matching = parsedURL.pathname.match(
    /^\/gifs\/(?:[^/]*-)?([a-zA-Z0-9]+)\/?$/
  );
  return matching
    ? `https://media.giphy.com/media/${matching[1]}/giphy.gif`
    : null;
};

export { getGiphyImageURL, parseComments, parseSelftext };

function parseVote(likes) {
  if (likes === null) return 0;
  return likes ? 1 : -1;
}
